import {combineReducers} from 'redux';
import navigationReducer from './navigationReducer';
import propertiesReducer from './propertiesReducer';
import nodeDatasReducer from './nodeDatasReducer';
import toastReducer from './toastReducer';
import nodeEditorPanelReducer from './nodeEditorPanelReducer';
import clickedNodeReducer from './clickedNodeReducer';
import logicDataReducer from './logicDataReducer';
import logicGraphDataReducer from './logicGraphDataReducer';
import analyticsDatePickerReducer from "./analyticsDatePickerReducer";
import contextPropertiesReducer from "./contextPropertiesReducer";
import contextUpdatersReducer from "./contextUpdatersReducer";
import itemPropertiesReducer from "./itemPropertiesReducer";
import multiLanguageReducer from "./multiLanguageReducer";
import attributesToRetrieveReducer  from "./attributesToRetrieveReducer";
import contextPropertiesToRetrieveReducer from './contextPropertiesToRetrieveReducer';
import logicsListReducer from './logicsListReducer';
import settingsToRetrieveReducer from "./settingsToRetrieveReducer";
import copyNodesReducer from "./copyNodesReducer";

const rootReducer = combineReducers({
    navigation: navigationReducer,
    properties: propertiesReducer,
    nodeDatas: nodeDatasReducer,
    toasts: toastReducer,
    modalInfo: nodeEditorPanelReducer,
    clickedNodeInfo: clickedNodeReducer,
    logicDataInfo: logicDataReducer,
    logicGraphData: logicGraphDataReducer,
    analyticsDatePicker: analyticsDatePickerReducer,
    contextProperties: contextPropertiesReducer,
    attributesToRetrieve: attributesToRetrieveReducer,
    contextPropertiesToRetrieve: contextPropertiesToRetrieveReducer,
    settingsToRetrieve: settingsToRetrieveReducer,
    contextUpdaters: contextUpdatersReducer,
    itemProperties: itemPropertiesReducer,
    currentLanguage: multiLanguageReducer,
    logicsList: logicsListReducer,
    copyNodes: copyNodesReducer
});

export default rootReducer;
